var _defs, _circle, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgAvatar0 = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3875",
    "data-name": "Group 3875",
    width: 70,
    height: 70,
    viewBox: "0 0 70 70",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_360",
    "data-name": "Ellipse 360",
    cx: 35,
    cy: 35,
    r: 35,
    fill: "#fff"
  })))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_361",
    "data-name": "Ellipse 361",
    cx: 35,
    cy: 35,
    r: 35,
    transform: "translate(0)",
    fill: "#f5f5f5"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_70",
    "data-name": "Mask Group 70",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_573",
    "data-name": "Group 573",
    transform: "translate(-3.5 -5.95)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_372",
    "data-name": "Ellipse 372",
    cx: 38.5,
    cy: 38.5,
    r: 38.5,
    transform: "translate(0 0)",
    fill: "#f5f5f5"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_572",
    "data-name": "Group 572",
    transform: "translate(2.469 20.098)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_24445",
    "data-name": "Path 24445",
    d: "M5361.491,1889.238s.079-.536-1.41-2.786-4.312-3.732-4.548-6.214,3.218-6.781,2-10.722-7.185-4.567-8.029-5.061-2.687-5-9.527-3.405-3.56,12.589-3.748,14.151c-.094.786-2.225,3.715-6.627,4.533-3.948.733-10.145-.656-13.409,1.583-6.569,4.505-5.619,10.94-5.619,10.94a39.542,39.542,0,0,0,5.11,8.938,50.376,50.376,0,0,0,6.043,6.152,8.049,8.049,0,0,1,1.219-.556C5335.677,1906.037,5361.491,1889.238,5361.491,1889.238Z",
    transform: "translate(-5310.529 -1860.711)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24446",
    "data-name": "Path 24446",
    d: "M0,.372,1.925,0",
    transform: "matrix(0.978, 0.208, -0.208, 0.978, 29.211, 13.448)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24447",
    "data-name": "Path 24447",
    d: "M5364.686,1881.892a10.248,10.248,0,0,1-3.187,3.223c-1.977,1.164-.3.583-1.463.736a3.515,3.515,0,0,1-2.648,0,6.137,6.137,0,0,1-2.65-3.311,20.973,20.973,0,0,1-.207-6.409c.63-2.755.573-3.374,2.177-4.677s4.339-.24,4.339-.24a5.825,5.825,0,0,1,2.812,2.445,6.378,6.378,0,0,1,.613,2.839c-.021.409-.342.184,0,.328a.673.673,0,0,1,.556-.393,1,1,0,0,1,1.148.919,3.747,3.747,0,0,1-.494,2.513A9.549,9.549,0,0,0,5364.686,1881.892Z",
    transform: "translate(-5323.682 -1863.039)",
    fill: "#e6ad9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24448",
    "data-name": "Path 24448",
    d: "M5361.174,1891.752a3.3,3.3,0,0,1,0,1.884,14.4,14.4,0,0,1-.709,2.305s2.649,2.97,4.867,2.813,4-3.438,4-3.438a5.058,5.058,0,0,1-2.058-2.833,20.45,20.45,0,0,1-.81-4.717Z",
    transform: "translate(-5325.508 -1868.827)",
    fill: "#e5ae9a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24449",
    "data-name": "Path 24449",
    d: "M5557.248,2082.573s-3.666-8.176-8.66-12.459-11.97-4.566-11.97-4.566-1.5,2.983-3.865,2.983-5.008-2.577-5.008-2.577-1.941-.494-5.914.66a20.805,20.805,0,0,0-9.352,5.189c-5.537,5.052-8.47,13.879-8.47,13.879s14.615,11.1,27.467,10.269S5557.248,2082.573,5557.248,2082.573Z",
    transform: "translate(-5492.861 -2039.062)",
    fill: "#608583"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24450",
    "data-name": "Path 24450",
    d: "M5365.169,1889.564a11.2,11.2,0,0,1-1.333,3.174,3.215,3.215,0,0,1-2.336,1.255l.167-.888-.167-.776,1.783-.95Z",
    transform: "translate(-5325.82 -1869.367)",
    fill: "#ce9582"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24451",
    "data-name": "Path 24451",
    d: "M5361.516,1876.441a2.159,2.159,0,0,1,1.17-.5,2.411,2.411,0,0,1,1.258.5",
    transform: "translate(-5325.823 -1864.579)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24452",
    "data-name": "Path 24452",
    d: "M5361.516,1876.441a2.159,2.159,0,0,1,1.17-.5,2.411,2.411,0,0,1,1.258.5",
    transform: "translate(-5330.724 -1864.579)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.4
  }), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_373",
    "data-name": "Ellipse 373",
    transform: "translate(31.131 12.802)",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.7,
    cy: 0.7,
    r: 0.7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.7,
    cy: 0.7,
    r: 0.2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_374",
    "data-name": "Ellipse 374",
    transform: "translate(36.031 12.802)",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.7,
    cy: 0.7,
    r: 0.7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.7,
    cy: 0.7,
    r: 0.2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_375",
    "data-name": "Ellipse 375",
    transform: "translate(40.231 17.702)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 0.7,
    cy: 0.7,
    r: 0.7,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 0.7,
    cy: 0.7,
    r: 0.2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Path_24453",
    "data-name": "Path 24453",
    transform: "translate(29.031 12.102)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.1,0A2.1,2.1,0,1,1,0,2.1,2.1,2.1,0,0,1,2.1,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 2.099999904632568 0.1999998092651367 C 1.052339792251587 0.1999998092651367 0.1999998092651367 1.052339792251587 0.1999998092651367 2.099999904632568 C 0.1999998092651367 3.147659778594971 1.052339792251587 4 2.099999904632568 4 C 3.147659778594971 4 4 3.147659778594971 4 2.099999904632568 C 4 1.052339792251587 3.147659778594971 0.1999998092651367 2.099999904632568 0.1999998092651367 M 2.099999904632568 0 C 3.259799957275391 0 4.199999809265137 0.9401998519897461 4.199999809265137 2.099999904632568 C 4.199999809265137 3.259799957275391 3.259799957275391 4.199999809265137 2.099999904632568 4.199999809265137 C 0.9401998519897461 4.199999809265137 0 3.259799957275391 0 2.099999904632568 C 0 0.9401998519897461 0.9401998519897461 0 2.099999904632568 0 Z",
    stroke: "none",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_376",
    "data-name": "Ellipse 376",
    transform: "translate(34.631 12.102)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.2
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 2.1,
    cy: 2.1,
    r: 2.1,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.1,
    cy: 2.1,
    r: 2,
    fill: "none"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_24454",
    "data-name": "Path 24454",
    d: "M5365.78,1879.651l2.2-.448",
    transform: "translate(-5327.102 -1865.559)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24455",
    "data-name": "Path 24455",
    d: "M5358.353,1880.152a11,11,0,0,0-1.01,2.3c.022.416,1.137.464,1.137.464Z",
    transform: "translate(-5324.571 -1865.844)",
    fill: "#ce9582"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24456",
    "data-name": "Path 24456",
    d: "M5357.663,1886.4l3.271-.065s-.96,1.688-1.777,1.7S5357.663,1886.4,5357.663,1886.4Z",
    transform: "translate(-5324.668 -1867.697)",
    fill: "#fff",
    stroke: "#ce9582",
    strokeWidth: 0.13
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_24457",
    "data-name": "Path 24457",
    d: "M5351.749,1879.821h1.939",
    transform: "translate(-5318.694 -1865.744)",
    fill: "none",
    stroke: "#fff",
    strokeWidth: 0.2
  }))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgAvatar0, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/avatar-0.46975eee.svg";
export { ForwardRef as ReactComponent };